export const MESSAGE_INPUT_CHANGE = 'input--change';
export const MESSAGE_INPUT_RECOGNIZE = 'input--recognize';
export const MESSAGE_INPUT_FOCUS = 'input--focus';
export const MESSAGE_INPUT_BLUR = 'input--blur';
export const MESSAGE_INPUT_INITIALIZE = 'input--initialize';
